import { styled } from '@mui/material/styles';
import { Paper, Button, FormHelperText, FormControl } from '@mui/material';

export const Cnt = styled('div')(({ theme }) => ({
  maxWidth: '700px',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: theme.spacing(-2)
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  }
}));

export const ButtonContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'isIntersecting'
})(({ theme, isIntersecting }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#EEE',
  padding: theme.spacing(),
  zIndex: 2,
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  // Apply borderTop and boxShadow only if NOT intersecting
  ...(!isIntersecting && {
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    boxShadow: 'rgba(0, 0, 0, 0.45) 0px -17px 20px -22px'
  })
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));

export const RadioContainer = styled(FormControl)(({ theme }) => ({
  marginTop: theme.spacing()
}));

export const StyledHelperText = styled(FormHelperText)(({ theme }) => ({
  marginLeft: theme.spacing(1.75),
  marginRight: theme.spacing(1.75)
}));
